import React from "react";
import "@fontsource/oswald"
import "@fontsource/roboto"
import "./App.scss";
import Sidebar from "./components/Sidebar/Sidebar";
import Footer from "./components/Footer/Footer";
import GoalProvider from "./store/GoalProvider";
import Locations from "./components/Locations/Locations"
import InfoBox from "./components/InfoBox/InfoBox";
import SlideOver from "./components/SlideOver/SlideOver";
import Map from "./components/Map/Map";
import GoalHeader from "./components/GoalHeader/GoalHeader";
import CloseButton from "./components/CloseButton/CloseButton";

function App() {
    return (
        <GoalProvider>
            <CloseButton/>
            <Sidebar/>
            <SlideOver>
                <GoalHeader />
                <Locations/>
                <Map />
                <InfoBox/>
            </SlideOver>
            <Footer/>
        </GoalProvider>
    );
}

export default App;
